(function () {
    let collapsibleWithImage = () => {
        $(".collapsible-with-image_item-wrapper").removeClass("active");

        $(".collapsible-with-image_item-wrapper").click(function () {
            $(this).toggleClass("active");
  
            $(this).siblings(".collapsible-with-image_item-wrapper").removeClass("active");
        });
    };

    document.addEventListener("shopify:section:load", function () {
        collapsibleWithImage();
    });

    collapsibleWithImage();
})();